module.exports = __webpack_public_path__ + "img/help.ffabb103.svg";